import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import find from 'lodash.find';
import { InitiativeActionCreators, AppActionCreators } from '../../../actions';
import { AttachmentType, InitiativeMode } from '../../../utils/enums';
import { Initiative } from './Initiative';
import { RouteUrls } from '../../../configs/routeUrls';

class InitiativeContainer extends Component {
	componentDidMount() {
		this.props.setBreadcrumbs([
			{
				url: RouteUrls.Initiative.default,
				displayName: 'Zgłoś inicjatywę'
			}
		]);
	}
	render() {
		const {
			isAuth,
			officeId,
			thematicAreas,
			districts,
			attachmentConfiguration,
			reCaptchaConfig,
			mapConfiguration,
			initiativeMode,
			isInitiativeCreating,
			createInitiative,
			appModule
		} = this.props;

		return (
			<Initiative
				isAuth={isAuth}
				officeId={officeId}
				thematicAreas={thematicAreas}
				districts={districts}
				attachmentConfiguration={attachmentConfiguration}
				reCaptchaConfig={reCaptchaConfig}
				mapConfiguration={mapConfiguration}
				mode={initiativeMode}
				isInitiativeCreating={isInitiativeCreating}
				onSubmit={createInitiative}
				appModule={appModule}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuth: state.app.isAuth,
		officeId: state.app.defaultOffice.id,
		thematicAreas: state.app.thematicAreas,
		districts: state.app.districts,
		attachmentConfiguration: find(state.app.attachmentConfiguration, { placeOfUse: AttachmentType.Initiative }) || {
			maxAttachmentQuantity: 3,
			maxAttachmentSize: 5,
			maxAllAttachmentsSize: 15
		},
		reCaptchaConfig: state.app.reCaptchaConfiguration || {
			reCaptchaKey: 'http://192.168.43.83:6000/api/recaptcha'
		},
		mapConfiguration: state.app.mapConfiguration,
		initiativeMode: state.app.initiativeConfiguration.mode || InitiativeMode.Hidden,
		isInitiativeCreating: state.initiative.isInitiativeCreating,
		appModule: state.app.appModule || { consultation: false, budget: false, probe: false, survey: false }
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...InitiativeActionCreators, ...AppActionCreators }, dispatch),
		goTo: (url) => dispatch(push(url))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(InitiativeContainer);
